import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.425 34.915c-7.829 0-14.198-6.37-14.198-14.198a1.515 1.515 0 0 1 3.03 0c0 6.158 5.01 11.168 11.168 11.168s11.168-5.01 11.168-11.168a1.515 1.515 0 1 1 3.03 0c0 7.829-6.37 14.198-14.198 14.198"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.425 29.914c-5.028 0-9.142-4.114-9.142-9.142V9.362C5.283 4.334 9.397.22 14.425.22s9.142 4.114 9.142 9.142v11.41c0 5.027-4.114 9.142-9.142 9.142M14.425 43.835a1.515 1.515 0 0 1-1.515-1.515v-8.536a1.515 1.515 0 0 1 3.03 0v8.536c0 .837-.678 1.515-1.515 1.515"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.534 44.22H9.316a1.515 1.515 0 1 1 0-3.03h10.218a1.515 1.515 0 0 1 0 3.03"
    }, null, -1)
  ])))
}
export default { render: render }